var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2432_2435)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2432_2435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5176 6.93164L11.5176 8.17366",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5167 5.42397C11.4543 5.42397 11.4038 5.37299 11.4038 5.31013C11.4038 5.24725 11.4543 5.19629 11.5167 5.19629",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5186 5.42397C11.5809 5.42397 11.6314 5.37299 11.6314 5.31013C11.6314 5.24725 11.5809 5.19629 11.5186 5.19629",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28027 14.7148H14.2156",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0774 10.9849C7.05266 10.9849 7.84327 10.1943 7.84327 9.219C7.84327 8.24373 7.05266 7.45312 6.0774 7.45312C5.10213 7.45312 4.31152 8.24373 4.31152 9.219C4.31152 10.1943 5.10213 10.9849 6.0774 10.9849Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2793 14.716V13.7834C3.2793 12.2381 4.53199 10.9854 6.07728 10.9854C7.62257 10.9854 8.87526 12.2381 8.87526 13.7834V14.716",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23343 9.11581C9.81712 9.68762 10.6164 10.0402 11.4981 10.0402C13.2855 10.0402 14.7345 8.59118 14.7345 6.80377C14.7345 5.01636 13.2855 3.56738 11.4981 3.56738C9.76479 3.56738 8.34973 4.92995 8.26562 6.64238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2432_2435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2432_2435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.75,
    height: 12.75,
    fill: "white",
    transform: "translate(2.5 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccStats);
export default __webpack_public_path__ + "static/media/acc-stats.8c8e29ea70057c3ff99d9505a2efc652.svg";
export { ForwardRef as ReactComponent };